import React from "react";
import { useNavigate } from "react-router-dom";
import { ExternalLink, BookOpen } from "lucide-react";
import { PageShell } from "../components/PageShell";
import { AppText, Button, Card, Section } from "../components/ui";
import { openExternal } from "../lib/api";
import { Seo } from "../components/Seo";

export default function APropos() {
  const navigate = useNavigate();
  return (
    <PageShell>
      <Seo title="La méthode, et toi" description="KM01 met la méthode « Libère ta foulée » au service de chaque coureur. Éric, ton coach, marche à tes côtés — le premier kilomètre bien posé, adapté à toi." />
      <AppText variant="display" className="mt-4">La méthode, et toi</AppText>
      <AppText variant="body" className="text-km-ontertiary mt-2">Ce qui compte, c'est toi et tes besoins : Éric est là pour t'accompagner avec sa méthode et son expérience de terrain.</AppText>
      <Card className="flex items-center gap-4 mt-4">
        <img src="/assets/coach/eric.jpg" alt="Éric, coach KM01" className="w-20 h-20 rounded-full object-cover border-4 border-km-coral shrink-0" />
        <div>
          <AppText variant="subtitle">Éric, notre coach</AppText>
          <AppText variant="caption" className="text-km-muted mt-1">Ton coach au quotidien · entraîneur depuis 1995 · expert running chez Top Performance depuis 1998 · auteur de « Libère ta foulée »</AppText>
        </div>
      </Card>

      <Section title="Pourquoi KM01">
        <AppText variant="body" className="text-km-ontertiary">En 25 ans, j'ai analysé plus de 25 000 foulées. Des débutants surtout. Et presque toujours la même histoire : un plan trouvé en ligne, identique pour tout le monde, des chaussures achetées sur un conseil de magasin, une montre qui dicte l'allure. Trois semaines plus tard, le genou ou le tibia dit stop, et la personne se dit qu'elle n'est « pas faite pour courir ».</AppText>
        <AppText variant="body" className="text-km-ontertiary mt-3">C'est faux. Tout le monde est fait pour courir. Ce qui manque, c'est le premier kilomètre bien posé : ta foulée, ton bassin, tes chaussures, ton écoute. KM01 met la méthode du cabinet à la portée de tous, pour moins de 5 € par mois.</AppText>
        <AppText variant="bodyStrong" className="mt-3">Le premier kilomètre est le plus important. Tous les autres en découlent.</AppText>
      </Section>

      <Section title="Aller plus loin">
        <div className="flex flex-col gap-2">
          <button onClick={() => openExternal("https://www.amazon.fr/dp/B0HGQH4S9N")} className="flex items-center gap-2 min-h-[44px]">
            <BookOpen size={18} className="text-km-coral" fill="currentColor" stroke="#fff" />
            <AppText variant="bodyStrong" className="text-km-coral">Le livre : Libère ta foulée</AppText>
          </button>
          <button onClick={() => openExternal("https://liberetafoulee.fr")} className="flex items-center gap-2 min-h-[44px]">
            <ExternalLink size={18} strokeWidth={2.5} className="text-km-coral" />
            <AppText variant="bodyStrong" className="text-km-coral">L'analyse de foulée en ligne complète</AppText>
          </button>
        </div>
      </Section>

      <div className="mt-10 flex justify-center">
        <Button title="Découvre ton profil — gratuit" onClick={() => navigate("/profil")} />
      </div>
    </PageShell>
  );
}
